module.exports = __webpack_public_path__ + "static/media/multiple_choice_image.35c6068a.jpg";